import FadeIn from './FadeIn.js';

export default FadeIn;
